import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixSlider from "@radix-ui/react-slider";
import { forwardRef, useEffect, useState } from "react";
export const slider = tailwindVariants({
    base: "relative flex touch-none select-none items-center justify-center",
    variants: {
        orientation: {
            horizontal: "h-4 w-full",
            vertical: "h-full w-4"
        }
    }
});
export const sliderTrack = tailwindVariants({
    base: "relative rounded-full bg-grey-5",
    variants: {
        orientation: {
            horizontal: "h-1 w-full",
            vertical: "h-full w-1"
        }
    }
});
export const sliderRange = tailwindVariants({
    base: "absolute rounded-full bg-teal-9",
    variants: {
        orientation: {
            horizontal: "h-full",
            vertical: "w-full"
        }
    }
});
export const Slider = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { className, formatTooltip, orientation = "horizontal", value, ...restOfProps } = param;
    const [isPointerDown, setIsPointerDown] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    useEffect(()=>{
        const handlePointerMove = ()=>setShowTooltip(true);
        const handlePointerUp = ()=>setIsPointerDown(false);
        if (isPointerDown) {
            window.addEventListener("pointermove", handlePointerMove);
            window.addEventListener("pointerup", handlePointerUp);
        }
        return ()=>{
            window.removeEventListener("pointermove", ()=>setShowTooltip(true));
            window.removeEventListener("pointerup", handlePointerUp);
        };
    }, [
        isPointerDown
    ]);
    return /*#__PURE__*/ _jsxs(RadixSlider.Root, {
        className: slider({
            orientation,
            className
        }),
        orientation: orientation,
        ref: ref,
        value: value,
        onPointerDown: ()=>setIsPointerDown(true),
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx(RadixSlider.Track, {
                className: sliderTrack({
                    orientation
                }),
                children: /*#__PURE__*/ _jsx(RadixSlider.Range, {
                    className: sliderRange({
                        orientation
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Tooltip, {
                label: !!value && !!formatTooltip && /*#__PURE__*/ _jsx("div", {
                    className: "text-12",
                    children: formatTooltip === null || formatTooltip === void 0 ? void 0 : formatTooltip(value)
                }),
                defaultOpen: showTooltip,
                delayDuration: 0,
                open: showTooltip,
                side: "right",
                sideOffset: 2,
                children: /*#__PURE__*/ _jsx(RadixSlider.Thumb, {
                    className: "block size-2 cursor-pointer rounded bg-white shadow-popover outline-none"
                })
            })
        ]
    });
});
Slider.displayName = "Slider";
